import { useContext } from 'react';
import { IgdFiltersContext } from '../contexts/IgdFiltersContext';

export const useIgdFiltersContext = () => {
    return useContext(IgdFiltersContext);
};
